<template>
    <div :class="[
        'phone-input',
        {
            'is-focused': isFocused,
            'is-errored': isValid === false,
            'is-valid': isValid,
            'is-filled': value !== '' && typeof value !== 'object',
            'is-disabled': disabled
        }
    ]">
        <div class="phone-input__container">
            <div class="phone-input__select-wrapper" ref="selectWrapper">
                <z-select
                    :clearable="false"
                    :data="preparedPhoneMasksData"
                    @input="onCountryChange"
                    :class="{'is-disabled': disabled}"
                ></z-select>
            </div>
            <z-input
                :placeholder="placeholder"
                :name="name"
                type="tel"
                :required="required"
                :mask="currentMask"
                ref="input"
                :disabled="disabled"
                v-model="value"
            ></z-input>
        </div>
        <span class="phone-input__error" v-html="error" v-if="error"></span>
    </div>
</template>

<script>

export default {
    name: 'phone-input',
    inheritAttrs: false,
    props: {
        required: Boolean,
        placeholder: String,
        name: String,
        phoneMasksData: {
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            currentMask: '',
            countryCode: '',
            value: null,
            error: '',
            isFocused: false,
            isValid: null
        }
    },
    created () {
        const selectedCountry = this.phoneMasksData.find(el => el.selected)
        if (selectedCountry) {
            this.currentMask = selectedCountry.mask
            this.countryCode = selectedCountry.text
        }
    },
    mounted () {
        this.initWatch()
    },
    computed: {
        preparedPhoneMasksData () {
            return this.phoneMasksData.map(el => {
                return {...el, text: this.optionTemplate(el)}
            })
        }
    },
    methods: {
        optionTemplate (data) {
            let iconHtml = data.icon ? `<z-icon name="${data.icon}"></z-icon>` : ''
            return `
                <span class="phone-input__option">
                    ${iconHtml}
                    <span>${data.text}</span>
                </span>
            `
        },
        onCountryChange (id) {
            const selectedCountry = this.phoneMasksData.find(el => el.id === id)
            if (selectedCountry) {
                this.currentMask = selectedCountry.mask
                this.countryCode = selectedCountry.text
            }
        },
        send () {
            this.$emit('change', `${this.countryCode} ${this.value}`)
        },
        initWatch () {
            this.$watch(
                '$refs.input.error',
                (value) => {
                    this.error = value
                }
            )

            this.$watch(
                '$refs.input.isValid',
                (value) => {
                    this.isValid = value
                }
            )

            this.$watch(
                '$refs.input.isFocused',
                (value) => {
                    this.isFocused = value
                }
            )

            this.$watch(
                'value',
                this.send
            )
        }
    }
}
</script>

<style lang="scss">
$errorColor: $token-colors-alert-text;
$errorColorLight: #f8866f;
$validColor: $token-colors-success-text;
$hoverColor: $token-colors-border-hover;
$focusColor: $token-colors-border-focus;

.phone-input {
    $parent: &;

    width: 100%;
    position: relative;

    &__container {
        transition: border-color 0.2s ease-in;
        border: 1px solid #afafaf;
        border-radius: 4px;
        display: flex;
    }

    &__error {
        font-size: 14px;
        color: $errorColor;
        position: relative;
        margin-left: 20px;
        display: block;
        line-height: 1.2;
        margin-top: 4px;
    }

    .z-input {
        &__input {
            border: none;
            border-radius: 0;
            padding-left: 8px;
        }

        &__placeholder {
            left: 8px;
        }

        &__error {
            display: none;
        }
    }

    &__option {
        display: flex;
        align-items: center;

        .z-icon {
            margin-right: 8px;
            width: 28px;
            height: 20px;
        }
    }

    &__select-wrapper {
        display: flex;
        align-items: center;
        height: 50px;
        padding-left: 6px;
    }

    .z-select {
        width: initial;
        background: #F3F4F4;
        border-radius: 4px;
        border: none;
        box-shadow: none;
        height: 32px;

        &__container {
            height: 100%;
        }

        &__container {
            padding: 0 8px;
            display: flex;
            align-items: center;
            width: initial;
        }

        &__selected {
            margin-bottom: 0;
            padding-right: 20px;
            display: flex;
            overflow: visible;
        }

        &__option {
            padding: 8px !important;
        }

        &__arrow {
            width: 16px !important;
            height: 16px !important;
            right: 7px;

            path {
                stroke: $token-colors-tertiary;
            }
        }
    }

    // hover state
    &:hover {
        #{$parent}__container {
            border-color: $hoverColor;
            color: $token-colors-text-hover;
        }
    }

    // filled state
    &.is-filled {
        #{$parent}__container {
            border-color: $focusColor;
        }
    }

    // errored state
    &.is-errored {
        #{$parent}__container {
            border-color: $errorColor;
        }
    }

    // focused state
    &.is-focused {
        #{$parent}__container {
            border-color: $focusColor;
        }
    }

    // valid state
    &.is-valid {
        #{$parent}__container {
            border-color: $validColor;
        }
    }

    // disabled state
    &.is-disabled {
        pointer-events: none;

        #{$parent}__container {
            border-color: $token-colors-border-disabled;
        }

        #{$parent}__container {
            color: $token-colors-text-disabled;
        }
    }

}
</style>
